module.exports = __webpack_public_path__ + "media/leipzig/exception-leipzig-36d3f4ba.webp";